import * as UIToolkit from '../../UIToolkit';

function getColWidth(cubes: CubeId[]): PhysicsMeasurement {
    let colWidth: PhysicsMeasurement = 0;

    cubes.forEach((cubeId: CubeId): void => {
        let size: PhysicsSize = UIToolkit.layerCubeSize(cubeId);

        colWidth = Math.max(colWidth, size.width);
    });

    return colWidth;
}

export {
    getColWidth
};
